module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Charging finished at {0}"},"de":{"label":"EV Ladung fertig am {0}"},"fr":{"label":"Charge terminée à {0}"},"it":{"label":"Ricarica completata alle {0}"}}')
  delete Component.options._Ctor
}
